export default "ui-view{display:block}\n";